/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_User_Already_ExistsInputs */

const en_api_error_user_already_exists = /** @type {(inputs: Api_Error_User_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A user with this email already exists.`)
};

const pt_br2_api_error_user_already_exists = /** @type {(inputs: Api_Error_User_Already_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um usuário com este e-mail já existe.`)
};

/**
* | output |
* | --- |
* | "A user with this email already exists." |
*
* @param {Api_Error_User_Already_ExistsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_user_already_exists = /** @type {((inputs?: Api_Error_User_Already_ExistsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_User_Already_ExistsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_user_already_exists(inputs)
	return pt_br2_api_error_user_already_exists(inputs)
});